<template>
  <div :class="{ loaderbox: !absoluteFlg, 'loaderbox-absolute': absoluteFlg }">
    <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
  </div>
</template>
<script>
export default {
  name: 'OverlayLoading',
  componentName: 'OverlayLoading',
  props: {
    absoluteFlg: {
      type: Boolean,
      require: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.loaderbox {
  height: 100vh;
  width: 100vw;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20000;
}
.loaderbox-absolute {
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20000;
}
</style>



// WEBPACK FOOTER //
// src/components/animations/OverlayLoading.vue